import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import EnrolmentWindows from '../enrolment-windows/enrolment-windows';
import { SectionContainer } from './styles';
import type { WindowsForm } from './types';

interface EnrollmentWindowsElementProps {
  form: WindowsForm;
  errors: IModularBenefitMessages;
  successes: IModularBenefitMessages;
}

const EnrollmentWindowsElement = ({
  form,
  errors,
  successes,
}: EnrollmentWindowsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <EnrolmentWindows errors={errors} successes={successes} />
    </FormProvider>
  </SectionContainer>
);

export default memo(EnrollmentWindowsElement);
